import { render, staticRenderFns } from "./PayrollTable.vue?vue&type=template&id=1a4063db&scoped=true&"
import script from "./PayrollTable.vue?vue&type=script&lang=js&"
export * from "./PayrollTable.vue?vue&type=script&lang=js&"
import style0 from "./PayrollTable.vue?vue&type=style&index=0&id=1a4063db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4063db",
  null
  
)

export default component.exports